import React from 'react';
import { Link } from 'react-router-dom';
import Icon from '../../../components/AppIcon';

const PerformanceMetricsRow = ({ metrics }) => {
    const data = [
        { label: "Global Rank", value: metrics?.global_rank ? `#${metrics.global_rank.toLocaleString()}` : "N/A", color: "text-slate-900" },
        { label: "Percentile", value: metrics?.percentile ? `Top ${metrics.percentile}%` : "Top --%", color: "text-slate-900" },
        { label: "Avg Score", value: metrics?.avg_score ? `${Math.round(metrics.avg_score)}%` : "0%", color: "text-emerald-500" },
        { label: "Total Interviews", value: metrics?.total_interviews !== undefined ? metrics.total_interviews : "0", color: "text-slate-900" }
    ];

    return (
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-4">
            {data.map((item, idx) => (
                <div key={idx} className="bg-white rounded-2xl border border-slate-200 p-4 shadow-sm flex flex-col justify-center">
                    <div className="mb-1 flex items-center gap-1.5">
                        <h3 className="text-[11px] font-bold text-slate-900">{item.label}</h3>
                        {(item.label === "Global Rank" || item.label === "Percentile") && (
                            <Link
                                to="/ranking-system"
                                className="flex h-4 w-4 items-center justify-center rounded-full text-slate-400 transition hover:bg-emerald-50 hover:text-emerald-600"
                                title="How rank is calculated"
                                aria-label="How rank is calculated"
                            >
                                <Icon name="Info" size={11} />
                            </Link>
                        )}
                    </div>
                    <p className={`text-xl font-bold ${item.color}`}>{item.value}</p>
                </div>
            ))}
        </div>
    );
};

export default PerformanceMetricsRow;
